export function initLocationMap () {
  const address = document.getElementById("map-data").dataset.address;
  if (!address) return;

  // Geocode the address to get coordinates
  const geocoder = new google.maps.Geocoder();

  geocoder.geocode({ address: address }, function (results, status) {
    if (status === "OK") {
      const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 14,
        center: results[0].geometry.location,
      });

      new google.maps.Marker({
        map: map,
        position: results[0].geometry.location,
      });
    } else {
      console.error("Geocode failed: " + status);
    }
  });
}